module.exports = __webpack_public_path__ + "static/media/m_women_clothing.d9545bf4.jpg";